import { useContext, useEffect, useMemo, useState } from "react";
import { ClientContext } from "../../state/ClientContext";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function ClientSignInInfo() {
  const location = useLocation();
  const { selectedClient, generateNewClientPassword, isGeneratingPassword } =
    useContext(ClientContext);
  const [displayedPassword, setDisplayedPassword] = useState(null);

  const password = useMemo(() => {
    if (displayedPassword) {
      return displayedPassword;
    }
    if (location.state && location.state.tempPassword) {
      return location.state.tempPassword;
    }
  });

  useEffect(() => {
    setDisplayedPassword(null);
  }, [selectedClient]);

  const handleGenerateNewPassword = async () => {
    if (!selectedClient) return;

    try {
      const newPassword = await generateNewClientPassword(selectedClient.id);
      setDisplayedPassword(newPassword);
      toast.success("New password generated successfully");
    } catch (error) {
      console.error("Error generating password:", error);
    }
  };

  if (!selectedClient) {
    return null;
  }
  return (
    <div
      className="client-profile-section"
      style={{
        marginBottom: "40px",
        backgroundColor: "#D9D9D9",
        padding: "16px",
      }}
    >
      <h1 style={{ textAlign: "left", fontWeight: "800" }}>
        Client sign-in info
      </h1>
      <p>Clients use this info to sign in to their My Compass account.</p>
      <table>
        <tbody>
          <tr>
            <td>Email:</td>
            <td>{selectedClient.email}</td>
          </tr>
          <tr>
            <td>Password:</td>
            <td>{password ?? ""}</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <button
                onClick={handleGenerateNewPassword}
                disabled={isGeneratingPassword}
                className="btn-primary"
                style={{
                  opacity: isGeneratingPassword ? 0.6 : 1,
                  cursor: isGeneratingPassword ? "not-allowed" : "pointer",
                }}
              >
                {isGeneratingPassword
                  ? "Generating..."
                  : "Generate new Password"}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
